module.exports = __webpack_public_path__ + "static/img/shsxqwdcy_2.62f5e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shsxqwdcy_2.jpg
// module id = V4q3
// module chunks = 15